import React from 'react';
import { Chip } from '@mui/material';
import { LANGUAGE_OPTIONS } from '@/constants/courses';

/**
 * 사용자 권한 셀 컴포넌트
 * 
 * 사용자 권한을 Chip으로 표시합니다.
 * 
 * @param {Object} params - DataGrid의 renderCell 파라미터
 * @param {Object} params.row - 행 데이터
 * @param {string} params.row.type - 사용자 권한 (관리자, 교육운영자, FT, 교육생)
 */
const UserTypeCell = ({ row }) => {
  // 권한별 뱃지 색상 구분
  const languageOption = LANGUAGE_OPTIONS.find(option => option.languageId === row.languageId);
  if (!languageOption) {
    return '-';
  }
  return (
    <Chip
      label={languageOption.languageName}
      size="small"
      color={languageOption.color || 'default'}
      variant="outlined"
    />
  );
};

export default UserTypeCell;
